// src/components/LoadingOverlay.tsx
import React from 'react';
import PipelineLoadingOverlay from './PipelineLoadingOverlay';
import { RequestType } from '../utils/pipelineSteps';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  requestType?: RequestType;
  query?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message,
  requestType = 'rag_query',
  query 
}) => {
  return (
    <PipelineLoadingOverlay
      isVisible={isVisible}
      requestType={requestType}
      query={query}
    />
  );
};

export default LoadingOverlay;
